import React from "react";
import "./HousekeepingHero.css";
import Navbar from "../../Header/Navbar";

const EventCleaningHero = () => {
  return (
    <>
      <Navbar />

      {/* HERO SECTION */}
      <section className="hk-hero">
        <div className="hk-container">
          
          {/* Main Title */}
          <h1 className="hk-title">Event Cleaning</h1>

          {/* Breadcrumb with links */}
          <p className="hk-subtitle">
            <a href="/" className="hk-link">Home</a> -{" "}
            <a href="/services" className="hk-link">Our Services</a> -{" "}
            <span>Event Cleaning</span>
          </p>

        </div>
      </section>

      {/* About Tag BELOW HERO */}
      <div className="hk-tag-wrapper">
        <div className="hk-tag">About This Service</div>
      </div>
     
    </>
  );
};

export default EventCleaningHero;
